import { useState } from "preact/hooks";
import style from "./Filters.css";

import { Context } from "../Context";

import {
  BudgetFilter,
  CategoryFilter,
  CityFilter,
  TagsFilter,
  CapacityFilter,
} from "/components";

const Filters = ({ filters, reqParams, onSetFilter, onStayOnLandingPage }) => {
  const [context, setContext] = useState({ filterOpen: "" });

  const {
    categoryFilter,
    budgetFilter,
    cityFilter,
    capacityFilter,
    selectedTags,
    lat,
    lng,
    zoom,
    selectedServices
  } = filters;

  const handleBreakingChange = () => {
    onStayOnLandingPage(false);
  };

  const conditionalRenderCapacityFilter = () => {
    if (categoryFilter == "locations") {
      return (
        <CapacityFilter
          id="mapCapacityFilter"
          capacityFilter={capacityFilter}
          onCapacitySelect={(capacityFilter) => {
            onSetFilter({ ...filters, capacityFilter });
          }}
        />
      );
    }
  };

  const handleGoogleMapLocationSelected = (location) => {
    if (location) {
      const { name, lat, lng } = location;
      onSetFilter({ ...filters, lat, lng, cityFilter: name, zoom });
    } else {
      onSetFilter({ ...filters, cityFilter: null });
    }
  };

  const handleTagSelected = (name) => {
    if (!selectedTags.includes(name)) {
      onSetFilter({ ...filters, selectedTags: [...selectedTags, name] });
    } else {
      let newSelectedTags = selectedTags.filter((tagName) => tagName !== name);
      onSetFilter({ ...filters, selectedTags: newSelectedTags });
    }
  };

  const handleServiceSelected = (name) => {
    if (!selectedServices.includes(name)) {
      onSetFilter({ ...filters, selectedServices: [...selectedServices, name] });
    } else {
      let newSelectedSerives = selectedServices.filter((tagName) => tagName !== name);
      onSetFilter({ ...filters, selectedServices: newSelectedSerives });
    }
  };

  return (
    <Context.Provider value={[context, setContext]}>
      <div class={style.filterContainer}>
        <div class={style.filterContent}>
          <CategoryFilter
            categoryFilter={categoryFilter}
            onSetCategoryFilter={(newCategoryFilter) => {
              if (categoryFilter !== newCategoryFilter) {
                onSetFilter({
                  cityFilter,
                  lat,
                  lng,
                  zoom,
                  categoryFilter: newCategoryFilter,
                  selectedTags: [],
                  selectedServices: []
                });
              } else {
                onSetFilter({ ...filters, newCategoryFilter });
              }
            }}
            onBreakingChange={handleBreakingChange}
          />

          <CityFilter
            cityFilter={cityFilter}
            onSetCityFilter={handleGoogleMapLocationSelected}
            onBreakingChange={handleBreakingChange}
          />
          {conditionalRenderCapacityFilter()}

          <BudgetFilter
            id="mapBudgetFilter"
            budgetFilter={budgetFilter}
            onBudgetSelect={(budgetFilter) =>
              onSetFilter({ ...filters, budgetFilter })
            }
          />
          <TagsFilter
            id="mapTagsFilter"
            reqParams={reqParams}
            selectedTags={selectedTags}
            onClearAllTags={() => onSetFilter({ ...filters, selectedTags: [], selectedServices: [] })}
            onTagSelected={(name) => handleTagSelected(name)}
            selectedServices={selectedServices}
            onServiceSelected={(name) => handleServiceSelected(name)}
            category={categoryFilter}
          />
        </div>
      </div>
    </Context.Provider>
  );
};

export { Filters };
